(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moro-cart"] && !Shopify.designMode) return;
  try {
    
  const dateInput = document.querySelector('[data-moro-date]');
  if (dateInput) {
    const validateDate = () => {
      if (dateInput.value && dateInput.value < dateInput.min) {
        dateInput.value = '';
        dateInput.setCustomValidity('please choose a date at least two days from today.');
        return false;
      }
      dateInput.setCustomValidity('');
      return true;
    };
    validateDate();
    dateInput.addEventListener('input', validateDate);
    dateInput.addEventListener('change', validateDate);
    const cartForm = dateInput.closest('form');
    if (cartForm) {
      cartForm.addEventListener('submit', (event) => {
        if (!validateDate()) {
          event.preventDefault();
          dateInput.reportValidity();
        }
      });
    }
  }
  document.querySelectorAll('input[name="attributes[Order method]"]').forEach((input) => {
    input.addEventListener('change', () => {
      const address = document.querySelector('[data-moro-address]');
      if (address) address.hidden = input.value !== 'Self-collection';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moro-home"] && !Shopify.designMode) return;
  try {
    
  function setMenu(open) {
    const menu = document.querySelector('#moro-mobile-menu');
    const menuToggle = document.querySelector('.moro-menu-toggle');
    const menuClose = document.querySelector('.moro-menu-close');
    if (!menu || !menuToggle) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    menuToggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('moro-menu-open', open);
    if (open && menuClose) menuClose.focus();
    if (!open) menuToggle.focus();
  }

  function activateMoroTab(panelId) {
    document.querySelectorAll('[data-moro-tab]').forEach((item) => {
      item.setAttribute('aria-selected', String(item.dataset.moroTab === panelId));
    });
    document.querySelectorAll('.moro-panel').forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('.moro-menu-toggle')) {
      setMenu(true);
      return;
    }

    if (event.target.closest('.moro-menu-close, .moro-menu-backdrop')) {
      setMenu(false);
      return;
    }

    const menuLink = event.target.closest('#moro-mobile-menu a');
    if (menuLink) setMenu(false);

    const tabControl = event.target.closest('[data-moro-tab], [data-moro-target]');
    if (!tabControl) return;
    const panelId = tabControl.dataset.moroTab || tabControl.dataset.moroTarget;
    activateMoroTab(panelId);
  });

  document.addEventListener('keydown', (event) => {
    const menu = document.querySelector('#moro-mobile-menu');
    if (event.key === 'Escape' && menu && menu.classList.contains('is-open')) setMenu(false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moro-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-moro-product-form]').forEach((form) => {
    const variantsNode = document.querySelector('[data-moro-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const variantInput = form.querySelector('[data-moro-variant-id]');
    const price = document.querySelector('[data-moro-product-price]');
    const groups = Array.from(form.querySelectorAll('[data-moro-option-group]'));
    const money = new Intl.NumberFormat('en-SG', { style: 'currency', currency: 'SGD' });
    const flavourCountInputs = Array.from(form.querySelectorAll('[data-moro-flavour-count]'));
    const flavourChoices = Array.from(form.querySelectorAll('[data-moro-flavour-choice]'));
    const flavourProperties = Array.from(form.querySelectorAll('[data-moro-flavour-property]'));
    const flavourLegend = form.querySelector('[data-moro-flavour-legend]');
    const flavourSummary = form.querySelector('[data-moro-flavour-summary]');
    const flavourMessage = form.querySelector('[data-moro-flavour-message]');
    const selectedVariant = () => variants.find((item) => String(item.id) === variantInput.value);
    const packSize = () => {
      const match = selectedVariant()?.title.match(/\d+/);
      return match ? Number(match[0]) : 0;
    };
    const selectedFlavourCount = () => Number(form.querySelector('[data-moro-flavour-count]:checked')?.value || 1);
    const selectedFlavours = () => flavourChoices.filter((input) => input.checked);
    const updateFlavourAllocation = () => {
      if (!flavourChoices.length) return;
      const count = selectedFlavourCount();
      if (count === flavourChoices.length) {
        flavourChoices.forEach((input) => {
          input.checked = true;
          input.disabled = true;
        });
        flavourLegend.textContent = '03 · all flavours included';
      } else {
        flavourChoices.forEach((input) => { input.disabled = false; });
        const checked = selectedFlavours();
        if (checked.length > count) {
          checked.slice(count).forEach((input) => { input.checked = false; });
        }
        if (!selectedFlavours().length) flavourChoices[0].checked = true;
        flavourLegend.textContent = `03 · choose ${count} flavour${count > 1 ? 's' : ''}`;
      }
      const chosen = selectedFlavours();
      flavourChoices.forEach((input) => {
        if (!input.checked) input.disabled = chosen.length >= count;
      });
      const size = packSize();
      const base = chosen.length ? Math.floor(size / chosen.length) : 0;
      let remainder = chosen.length ? size % chosen.length : 0;
      const parts = [];
      flavourProperties.forEach((property) => {
        const choice = flavourChoices.find((input) => input.value === property.dataset.flavour);
        let amount = 0;
        if (choice?.checked) {
          amount = base + (remainder > 0 ? 1 : 0);
          if (remainder > 0) remainder -= 1;
          parts.push(`${property.dataset.flavour} × ${amount}`);
        }
        property.value = amount;
      });
      flavourSummary.textContent = parts.join(' · ');
      flavourMessage.textContent = '';
    };
    const syncVariant = () => {
      const selected = groups.map((group) => group.querySelector('input:checked')?.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      variantInput.value = variant.id;
      price.textContent = money.format(variant.price / 100);
      updateFlavourAllocation();
    };
    groups.forEach((group) => group.addEventListener('change', syncVariant));
    flavourCountInputs.forEach((input) => input.addEventListener('change', updateFlavourAllocation));
    flavourChoices.forEach((input) => input.addEventListener('change', updateFlavourAllocation));
    updateFlavourAllocation();
    form.addEventListener('submit', (event) => {
      if (!flavourChoices.length) return;
      const count = selectedFlavourCount();
      const chosen = selectedFlavours();
      if (chosen.length !== count) {
        event.preventDefault();
        flavourMessage.textContent = `choose exactly ${count} flavour${count > 1 ? 's' : ''}.`;
        flavourMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
